import { AppearanceTypes, Options, useToasts } from 'react-toast-notifications';

const useCustomToast = () => {
  const { addToast } = useToasts();

  const baseToast = (content: string, extraProps?: ToastOptions): void => {
    addToast(content, extraProps as Options);
  };

  return {
    addSuccessToast: (content: string, extraProps?: ToastOptions) =>
      baseToast(content, {
        appearance: 'success',
        autoDismiss: true,
        autoDismissTimeout : 15000,
        ...extraProps,
        
      }),
    addErrorToast: (content: string, extraProps?: ToastOptions) =>
      baseToast(content, {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 15000,
        ...extraProps,
      }),
    addWarningToast: (content: string, extraProps?: ToastOptions) =>
      baseToast(content, {
        appearance: 'warning',
        autoDismiss: true,
        autoDismissTimeout : 15000,
        ...extraProps,
      }),
    addInfoToast: (content: string, extraProps?: ToastOptions) =>
      baseToast(content, {
        appearance: 'info',
        ...extraProps,
      }),
  };
};

export default useCustomToast;

type ToastOptions = {
  appearance?: AppearanceTypes;
  autoDismiss?: boolean;
  autoDismissTimeout? : number;
  onDismiss?: (id: string) => void;
};
